module.exports = __webpack_public_path__ + "img/jonzac.c6476e1d.jpg";